import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import NonBypassEKYC from './NonBypassEKYC';
import { useLocation } from 'react-router-dom';
import { addUserData } from '../redux/slices/userTypeSlice';

function DynamicEKYC() {
  const userData =  useSelector(state => state.userTypeSlice.userData);
  const location = useLocation();
  const dispatch = useDispatch();

  const catgryId = location.state;
  const { type, from } = location.state || {};

  useEffect(() => {
    if (type === 'pan') {
      // Always disable bypass for cart flow

      dispatch(addUserData({userData: {...userData, ekyc_bypass: false}}));
    } 
  }, [location.state]);

  if(userData?.ekyc_bypass) {
    return (
      <NonBypassEKYC/> 
    )
  }
  return (
    <NonBypassEKYC from={from} type={type} catgryId={catgryId} />  )
}

export default DynamicEKYC